import { render, staticRenderFns } from "./PickupPointNew.vue?vue&type=template&id=e59308c2&"
import script from "./PickupPointNew.vue?vue&type=script&lang=js&"
export * from "./PickupPointNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports